module.exports = __webpack_public_path__ + "static/media/SellerboxFuncIconReport.2ee2c057.png";